import React from 'react';
import { Box, Typography } from '@mui/material';
import { AttendanceCard } from './cards/AttendanceCard';
import { NotificationSummaryCard } from './cards/NotificationSummaryCard';
import { NotificationHistoryCard } from './cards/NotificationHistoryCard';
import { CriticalStudentsCard } from './cards/CriticalStudentsCard';
import { useSchoolClass } from 'pages/SchoolClass/hooks/useSchoolClass';

type SchoolClassHookReturn = ReturnType<typeof useSchoolClass>;

export interface ClassSidebarSummaryProps {
  state: SchoolClassHookReturn['state'];
}

export function ClassSidebarSummary({ state }: ClassSidebarSummaryProps) {
  const { 
    attendanceData, 
    isFetchingAttendance, 
    notificationStats, 
    isLoadingStats,
    criticalStudents, 
    isLoadingCritical
  } = state;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, height: '100%', flex: 1 }}>
      <Typography variant="h6" fontWeight="bold" color="text.primary" sx={{ mb: 1 }}>
        Indicadores e Alertas de Turma
      </Typography>

      <AttendanceCard 
        attendanceData={attendanceData} 
        isFetching={isFetchingAttendance} 
      />

      <NotificationSummaryCard 
        stats={notificationStats} 
        isLoading={isLoadingStats} 
      />

      <NotificationHistoryCard 
        history={notificationStats?.history30Days || []} 
        isLoading={isLoadingStats} 
      />

      <CriticalStudentsCard 
        students={criticalStudents} 
        isLoading={isLoadingCritical} 
      />
    </Box>
  );
}